import { render, staticRenderFns } from "./distributionSetting.vue?vue&type=template&id=45125e70&scoped=true"
import script from "./distributionSetting.vue?vue&type=script&lang=js"
export * from "./distributionSetting.vue?vue&type=script&lang=js"
import style0 from "./distributionSetting.vue?vue&type=style&index=0&id=45125e70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45125e70",
  null
  
)

export default component.exports